import { useTranslation } from "react-i18next";
import { ButtonLink } from "./Button";
import { useIsAdmin } from "../hooks/useIsAdmin";
import { getGcpLogsConsoleUrl } from "../config/gcpLogsConsole";

type Props = {
  searchId: string;
};

export const GcpLogsConsoleButton = ({ searchId }: Props) => {
  const { t } = useTranslation();
  const isAdmin = useIsAdmin();
  if (!isAdmin || !searchId.trim()) {
    return null;
  }
  const href = getGcpLogsConsoleUrl(searchId);
  return (
    <ButtonLink href={href} target="_blank" rel="noopener noreferrer" $variant="outlined">
      {t("gcpLogs.openQuery")}
    </ButtonLink>
  );
};
